import { FC } from 'react'
import { Typography } from '@mui/material'
import { CostDitributionWrapper, CostDistributionHeader, CostDistributionList } from './productCostDistribution.styles'
import CostDistributionChip from './CostDistributionChip'
import CostDistributionItem from './CostDistributionItem'

interface Props {
  items: any
  isManual?: boolean
}

const ProductCostDistribution: FC<Props> = ({ items, isManual }) => {
  return (
    <CostDitributionWrapper>
      <CostDistributionHeader>
        <Typography className="title">Cost Distribution</Typography>
        {items.length > 1 && isManual && <CostDistributionChip text="Manual" />}
      </CostDistributionHeader>

      {items.length > 1 ? (
        <CostDistributionList className="cost-distribution-list">
          {items.map((item: any, index: number) => (
            <CostDistributionItem key={index} item={item} />
          ))}
        </CostDistributionList>
      ) : (
        <Typography className="solo-cost-distribution-text">Used in this area only</Typography>
      )}
    </CostDitributionWrapper>
  )
}

export default ProductCostDistribution
